// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IFNL","buttons":"styles_buttons__uMS15"};